import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AddFuelType from "./AddFuelType";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import Switch from "@mui/material/Switch";
import {
  EditIcon,
  AddIcon,
  SearchIcon,
  NotInterestedIcon,
  CloudOffIcon,
  DoneOutlineIcon,
} from "../../../Resources/Icons/icons";
import {
  GetFuelType,
  UpdateFuelType,
  FilterFuelType,
} from "../../../Service/_index";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../../UiComponents/Transition/Transition";
import { Divider } from "@mui/material";
import TabFilter from "../../../Components/Tabs/Tabs";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import DisabledImage from "../../../../src/Resources/Images/disable.png";
import ActiveImage from "../../../../src/Resources/Images/ActiveImage.png";
import { set } from "rsuite/esm/internals/utils/date";

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const FilterOption = [
  {
    label: "All Data",
    isEnabled: "all",
    value: 1,
  },
  {
    label: "ActiveData",
    isEnabled: "true",
    value: 2,
  },
  {
    label: "In ActiveData",
    isEnabled: "false",
    value: 3,
  },
];

const getClassName = (data) => {
  return data.status == "Active"
    ? "Active-chip"
    : data.status == "Inactive"
    ? " inActive-chip"
    : "";
};

const headCells = [
  {
    id: "fuelType",
    placeMent: true,
    disablePadding: false,
    label: "FuelType",
  },
  {
    id: "remarks",
    placeMent: true,
    disablePadding: false,
    label: "Remark",
  },
  {
    id: "createdAt",
    placeMent: true,
    disablePadding: false,
    label: "Created Date",
  },
  {
    id: "updatedAt",
    placeMent: true,
    disablePadding: false,
    label: "Updated Date",
  },
  {
    id: "status",
    placeMent: true,
    disablePadding: false,
    label: "Status",
    class: getClassName,
  },
  // {
  //   id: "action",
  //   placeMent: false,
  //   disablePadding: false,
  //   label: "Action",
  // },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const FuelType = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedData, setSelectedData] = React.useState({});
  const [openFuelTypeDrawer, setOpenFuelTypeDrawer] = React.useState(false);
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [fuelType, setFuelType] = React.useState([]);
  const [searchText, setSearchText] = useState("");
  const [activeBoolean, setActiveBoolean] = useState();
  const [pageView, setPageView] = useState(2);
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    isEdit: true,
    isSearch: true,
    isSwitch: true,
    historyEntity: "fuelType",
  });
  const [selectedTab, setSelectedTab] = useState(1);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    const selectedOption = FilterOption.find(
      (option) => option.value === newValue
    );
    FilterFuelTypeFunction(selectedOption);
  };

  const FilteredData = fuelType.filter((el) => {
    console.log("Element:", el);
    return `${el?.fuelType},${el?.remark}`
      .toLowerCase()
      .includes(searchText.toLowerCase());
  });

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(fuelType), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, fuelType]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const GetData = () => {
    setLoading(true);
    GetFuelType().then((res) => {
      const updatedData = res?.data.map((item) => ({
        ...item,
        createdAt: moment(item.createdAt).format("DD/MM/YYYY hh:mm A"),
        updatedAt: moment(item.updatedAt).format("DD/MM/YYYY hh:mm A"),
        status: item.isEnabled ? "Active" : "Inactive",
      }));
      setFuelType(updatedData);
    });
    setLoading(false);
  };
  const GetActiveData = () => {
    setLoading(true);
    GetFuelType().then((res) => {
      const updatedData = res?.data.map((item) => ({
        ...item,
        createdAt: moment(item.createdAt).format("DD/MM/YYYY hh:mm A"),
        updatedAt: moment(item.updatedAt).format("DD/MM/YYYY hh:mm A"),
        status: item.isEnabled ? "Active" : "Inactive",
      }));
      setFuelType(updatedData.filter((item) => item.isEnabled === true));
    });
    setLoading(false);
  };
  const GetInActiveData = () => {
    setLoading(true);
    GetFuelType().then((res) => {
      const updatedData = res?.data.map((item) => ({
        ...item,
        createdAt: moment(item.createdAt).format("DD/MM/YYYY hh:mm A"),
        updatedAt: moment(item.updatedAt).format("DD/MM/YYYY hh:mm A"),
        status: item.isEnabled ? "Active" : "Inactive",
      }));
      setFuelType(updatedData.filter((item) => item.isEnabled === false));
    });
    setLoading(false);
  };

  React.useEffect(() => {
    GetData();
  }, []);

  const EditFuelTypeData = (row) => {
    setSelectedData(row);
    setOpenFuelTypeDrawer(true);
  };

  const CreateFuelTypeData = () => {
    setSelectedData({});
    setOpenFuelTypeDrawer(true);
  };

  const ActiveFuelTypeData = (row, active) => {
    setOpenConfirmBox(true);
    setSelectedData(row);
    setActiveBoolean(!active);
  };
  const ActiveFunction = (event) => {
    UpdateFuelType(selectedData._id, { isEnabled: activeBoolean }).then(
      (res) => {
        switch (pageView) {
          case 1:
            GetData();
            break;
          case 2:
            GetActiveData();
            break;
          case 3:
            GetInActiveData();
            break;
          default:
            break;
        }
      }
    );
    setOpenConfirmBox(false);
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el.fuelType},${el.remarks}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const FilterFuelTypeFunction = (e) => {
    setPageView(e?.value);
    let data = e?.isEnabled;
    let apiMethod =
      data === "all"
        ? GetData()
        : FilterFuelType({ isEnabled: data }).then((res) => {
            setFuelType(res?.data);
            const updatedData = res?.data.map((item) => ({
              ...item,
              createdAt: moment(item.createdAt).format("DD/MM/YYYY hh:mm A"),
              updatedAt: moment(item.updatedAt).format("DD/MM/YYYY hh:mm A"),
              status: item.isEnabled ? "Active" : "Inactive",
            }));
            setFuelType(updatedData);
          });
    setPage(0);
  };
  return (
    <>
      <Grid container className="Master_Card_Container">
        <Grid
          container
          alignItems={"center"}
          className="Master_Card_Sub_Container"
        >
          <Grid item xs={12} sm={6} md={6}>
            <Typography className="Master_Card_Tittle">Fuel Type</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            className="d-flex justify-content-end"
          >
            <Button
              className="Master_Card_create_Button w-100"
              startIcon={
                <AddIcon
                  sx={{
                    marginRight: "1.5px",
                  }}
                />
              }
              onClick={() => CreateFuelTypeData()}
            >
              Create
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider
            sx={{
              backgroundColor: "#EAECF0",
              borderWidth: 1,
            }}
          />
        </Grid>
        <Grid
          container
          alignItems={"center"}
          justifyContent={"space-between"}
          className="Master_Card_Sub_Container"
        >
          <TabFilter
            options={FilterOption}
            selectedTab={selectedTab}
            onTabChange={handleTabChange}
          />
          <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
            <Input
              focused="false"
              className="w-100 Master_Card_Input"
              id="standard-adornment-password"
              // onChange={onSearch}
              onChange={(e) => {
                setSearchText(e.target.value);
                setPage(0);
              }}
              disableUnderline={true}
              placeholder="Search in FuelType"
              startAdornment={
                <InputAdornment position="start" sx={{ marginRight: "0px" }}>
                  <IconButton aria-label="toggle password visibility">
                    <SearchIcon
                      sx={{
                        fontSize: "20px",
                      }}
                    />
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
        </Grid>
        <MasterCommonTable
          tableConfig={tableConfig}
          data={FilteredData}
          columns={headCells}
          handleEdit={EditFuelTypeData}
          handleApprove={ActiveFuelTypeData}
          tableTotalCount={filter.fn(fuelType)?.length || 0}
          loading={loading}
        />
      </Grid>

      <Dialog
        open={openFuelTypeDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            maxWidth: {
              xs: "80%",
              sm: "70%",
              md: "50%",
              lg: "40%",
            },
          },
        }}
      >
        {openFuelTypeDrawer ? (
          <AddFuelType
            title={selectedData._id ? "Edit" : "Create"}
            selectedData={selectedData}
            formType={selectedData._id ? "edit" : "add"}
            setOpenFuelTypeDrawer={setOpenFuelTypeDrawer}
            GetActiveData={GetActiveData}
            GetData={GetData}
          />
        ) : null}
      </Dialog>
      <ConfirmBox
        open={openConfirmBox}
        title={selectedData.isEnabled ? "Inactive" : "Active"}
        content={`Are you sure want to ${
          selectedData.isEnabled ? "Inactive" : "Active"
        }`}
        confirmButton={selectedData.isEnabled ? "Inactive" : "Active"}
        setOpenConfirmBox={setOpenConfirmBox}
        Function={ActiveFunction}
        img={selectedData.isEnabled ? DisabledImage : ActiveImage}
        icon={
          selectedData.isEnabled ? <NotInterestedIcon /> : <DoneOutlineIcon />
        }
        color={selectedData.isEnabled ? "error" : "success"}
      />
    </>
  );
};
export default FuelType;
